module.exports = __webpack_public_path__ + "./Jane_b61a9dc7f7215ff22013c46406468ad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Jane.jpg
// module id = 556
// module chunks = 0